<template>
    <div class="text-center text-slate-700 font-sans mb-8">
        <h3
            class="font-extrabold text-2xl leading-7 flex justify-center items-center gap-3 mb-3"
        >
            <font-awesome-icon widthAuto
                :icon="props.icon"
                class="text-base"
            ></font-awesome-icon>
            <span>
                <slot></slot>
            </span>
        </h3>
        <p class="text-base leading-6 font-normal">
            <slot name="description"></slot>
        </p>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
    icon: {
        type: Object,
        required: true,
    },
});
</script>
